export function getLocalBuildId() {
  const raw = import.meta.env.VITE_BUILD_ID
  const buildId = typeof raw === 'string' ? raw.trim() : ''
  return buildId || 'dev'
}

export function getLocalBuiltAt() {
  const raw = import.meta.env.VITE_BUILT_AT
  const builtAt = typeof raw === 'string' ? raw.trim() : ''
  return builtAt || null
}
